import Utils from "../misc/Utils";
import Alert from "./Alert";

class Memes {
    static handleScrollMemeVideos(){
        let $videos = jQuery('.tile.meme video');
        if($videos.length <= 0){
            return false;
        }
        $videos.each(function (){
            let video = this;
            if(Utils.isInViewport(video) && !jQuery(video).hasClass('stopped')) {
                jQuery(video).addClass('playing');
                video.play().catch(function () {
                    jQuery(video).removeClass('playing');
                });
            } else {
                jQuery(this).removeClass('playing');
                this.pause();
            }
        });
    };
    static fetchMemes() {
        let $anchor = jQuery('[data-fetch-memes]');
        let offset = jQuery('.tile.meme').length;
        let $wrapper = jQuery('.container_box.memes').find('.tiles');
        let data = {
            'offset' : offset,
            'sorting' : $anchor.attr('data-meme-sorting')
        }
        if($anchor.attr('data-meme-tag') !== '') {
            data['tag_id'] = $anchor.attr('data-meme-tag-id');
        }
        Utils.commit_ajax_action('fetch_memes', data, function(response) {
            if(response && response.status && response.status === 'error') {
                $anchor.remove();
                if(response.message) {
                    Alert.showGeneralAlert(response.message);
                } else {
                    Alert.showGeneralAlert("Error fetching memes, try again later");
                }
                return false;
            }
            if(response.cargo.html === ''){
                $anchor.remove();
            }
            let $html = jQuery(response.cargo.html);
            $wrapper.append($html);
            Utils.initClipboard($html);
            $anchor.removeClass('loading');
        }, function() {
            $anchor.remove();
            Alert.showGeneralAlert("Something went wrong, try refreshing the page");
        });
    };
    static handleMemesFetch() {
        let $anchor = jQuery('[data-fetch-memes]');
        if($anchor.length <= 0) {
            return false;
        }
        if(Utils.isInViewport($anchor[0]) && !$anchor.hasClass('loading')) {
            $anchor.addClass('loading');
            Memes.fetchMemes();
        }
    };

    static fetchRandomMeme() {
        return new Promise(function (resolve, reject) {
            Utils.commit_ajax_action('fetch_random_top_meme', false, function (response) {
                if (response && response.status && response.status === 'error') {
                    if (response.message) {
                        Alert.showGeneralAlert(response.message);
                    } else {
                        Alert.showGeneralAlert("Error fetching random top meme, try refreshing the page");
                    }
                    return reject();
                }
                return resolve(jQuery(response.cargo.html));
            }, function () {
                Alert.showGeneralAlert("Something went wrong, try refreshing the page");
                return reject();
            });
        });
    }

    static handleSubMenu(scrollPos, scrollSpeed, direction){
        if(!jQuery(document.body).hasClass('mobile')) {
            return false;
        }
        let $memesTagsWrapper = jQuery('.memes-tags-wrapper');
        if(scrollPos >= 100) {
            $memesTagsWrapper.parent().addClass('fixed');
            $memesTagsWrapper.addClass('fixed');
        } else if(scrollPos <= 16){
            $memesTagsWrapper.parent().removeClass('fixed');
            $memesTagsWrapper.removeClass('fixed');
        }
        if(direction === 'up') {
            if(scrollSpeed >= 0.8) { //px per ms
                $memesTagsWrapper.addClass('show');
            }
        } else {
            $memesTagsWrapper.removeClass('show');
        }
    }

    static initEvents() {
        jQuery('[data-fetch-random-meme]').on('click', function () {
            let $content = jQuery(this).parents('.memes-side-box').find('.tiles');
            Memes.fetchRandomMeme()
                .then(function ($html) {
                    $content.html($html);
                })
                .catch(function () {
                    jQuery('[data-fetch-random-meme]').hide();
                });
        });
        jQuery(document.body).on('click', '.meme video, .meme .play-wrapper', function () {
            let $video = jQuery(this).parents('.meme').find('video');
            if($video.hasClass('playing')) {
                $video.get(0).pause();
                $video.addClass('stopped').removeClass('playing');
            } else {
                $video.get(0).play();
                $video.removeClass('stopped').addClass('playing');
            }
        });
        jQuery(document.body).on('click', '[data-meme-volume-control]', function () {
            let $video = jQuery(this).parents('.thumb:first').find('video');
            if($video.get(0).muted) {
                jQuery('.tile.meme video').each(function () {
                    this.muted = false;
                    jQuery(this).parents('.thumb:first').find('.volume-icon').removeClass('mute').addClass('volume');
                });
                Utils.setCookie('_mv', '1', 365*60);
            } else {
                jQuery('.tile.meme video').each(function () {
                    this.muted = true;
                    jQuery(this).parents('.thumb:first').find('.volume-icon').removeClass('volume').addClass('mute');
                });
                Utils.removeCookie('_mv');
            }
        });
        jQuery('.add-meme-link').on('click', function (evt) {
            if(!jQuery(this).hasClass('active')) {
                jQuery('html,body').animate({scrollTop: 0},250, 'swing');
            }
        });
    }
    static initModule() {
        Memes.initEvents();
    }
}

export default Memes;
